import { styled } from '@mui/material/styles';
import { Button } from '@mui/material';
import LoadingButton from '@mui/lab/LoadingButton';

export const AvatarButton = styled(Button)(({ theme }) => ({
  color: theme.palette.text.secondary,
  borderColor: theme.palette.text.secondary,
  textTransform: 'none',
  minWidth: '150px'
}));

export const AvatarLoadingButton = styled(LoadingButton)(({ theme }) => ({
  color: theme.palette.text.secondary,
  borderColor: theme.palette.text.secondary,
  textTransform: 'none',
  minWidth: '150px'
}));

export const CancelButton = styled(Button)(({ theme }) => ({
  color: theme.palette.red.main,
  borderColor: theme.palette.red.main,
  textTransform: 'none'
}));

export const DeleteButton = styled(LoadingButton)(({ theme }) => ({
  color: theme.palette.text.secondary,
  borderColor: theme.palette.text.secondary,
  textTransform: 'none',
  textDecoration: 'underline',
  fontWeight: '400'
})); 